import React from 'react';
import {useTabsKeyboard} from '@hooks/keyboard';
import {SkipToContent} from './SkipToContent';

interface KeyboardNavigationProviderProps {
    children: React.ReactNode;
}

export const KeyboardNavigationProvider: React.FC<KeyboardNavigationProviderProps> = ({
    children
}) => {
    useTabsKeyboard();

    return (
        <>
            <SkipToContent />
            {children}
        </>
    );
};
